import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 1.22211C0 0.770715 0.366403 0.404785 0.817038 0.404785H12.2442C12.6954 0.404785 13.0612 0.768886 13.0612 1.22211V2.03744H2.59267C2.06318 2.03744 1.63265 2.4661 1.63265 2.99488V11.8334H0.817038C0.3658 11.8334 0 11.4693 0 11.016V1.22211Z",
      fill: "#2C3647"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 4.22211C3 3.77072 3.3664 3.40479 3.81704 3.40479H15.2442C15.6954 3.40479 16.0612 3.76889 16.0612 4.22211V5.03744H5.59267C5.06318 5.03744 4.63265 5.4661 4.63265 5.99488V14.8334H3.81704C3.3658 14.8334 3 14.4693 3 14.016V4.22211Z",
      fill: "#2C3647"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.93896 6.83442C5.93896 6.38302 6.30537 6.01709 6.756 6.01709H18.1832C18.6344 6.01709 19.0002 6.38119 19.0002 6.83442V16.6283C19.0002 17.0797 18.6338 17.4457 18.1832 17.4457H10.0222L8.30631 19.0783L7.6574 17.4457H6.756C6.30477 17.4457 5.93896 17.0816 5.93896 16.6283V6.83442ZM10.3471 10.262C10.798 10.262 11.1635 9.89651 11.1635 9.44566C11.1635 8.99482 10.798 8.62933 10.3471 8.62933C9.89629 8.62933 9.53081 8.99482 9.53081 9.44566C9.53081 9.89651 9.89629 10.262 10.3471 10.262ZM15.4084 9.44566C15.4084 9.89651 15.0429 10.262 14.592 10.262C14.1412 10.262 13.7757 9.89651 13.7757 9.44566C13.7757 8.99482 14.1412 8.62933 14.592 8.62933C15.0429 8.62933 15.4084 8.99482 15.4084 9.44566ZM9.83105 13.5411C9.71999 13.6178 9.64009 13.6793 9.59413 13.7181C9.42184 13.8635 9.40002 14.121 9.54539 14.2933C9.69075 14.4656 9.94827 14.4874 10.1206 14.342C10.1472 14.3196 10.2063 14.274 10.2948 14.2129C10.4465 14.1082 10.6213 14.0028 10.8157 13.9044C12.1339 13.2371 13.5091 13.2371 14.8186 14.342C14.9909 14.4874 15.2484 14.4656 15.3938 14.2933C15.5392 14.121 15.5173 13.8635 15.345 13.7181C13.7521 12.374 12.0313 12.374 10.447 13.1761C10.2181 13.292 10.0119 13.4162 9.83105 13.5411Z",
      fill: "#2C3647"
    }, null, -1)
  ]))]))
}
export default { render: render }